import { ExamNumberComponent } from "./recover-candidate-number/exam-number/exam-number.component";
import { RecoverCandidateNumberComponent } from "./recover-candidate-number/recover-candidate-number.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { authSimpleCanActivate } from "@delon/auth";
import { UserGuard } from "src/app/core/guards/user.guard";
import { userOnboardingCanActivate } from "src/app/core/guards/user-onboarding.guard";
import { nigeriaOnlyCanActivate } from "src/app/core/guards/exam-country.guard";
import { pageRoutes } from "src/app/core/config/page-routes.config";
import { LayoutDefaultComponent } from "src/app/layout/default/default.component";
import { ProvisionComponent } from "./provision/provision.component";

const routes: Routes = [
  {
    path: "",
    component: LayoutDefaultComponent,
    canActivate: [authSimpleCanActivate],
    canActivateChild: [UserGuard, userOnboardingCanActivate],
    data: {
      title: "Candidate Certificate",
      titleI18n: "PAGE_TITLES.PROVISION",
    },
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "certificate",
      },
      {
        path: "certificate",
        component: ProvisionComponent,
        data: {
          title: "Access Certificate", // title: "Provision Certificate",
          titleI18n: "GENERAL.ACCESS_CERTIFICATE",
        },
      },
      {
        path: "sharing",
        loadChildren: () => import('./share/share.module').then((m)=> m.ShareModule),
      },
      {
        path: "recover-candidate-no",
        component: RecoverCandidateNumberComponent,
        canActivate: [nigeriaOnlyCanActivate(pageRoutes.access.accessing)],
        data: {
          title: "Retrieve Candidate Number",
          titleI18n: "GENERAL.RETRIEVE_CANDIDATE_NUMBER",
        },
      },
      {
        path: "recover-candidate-no/:no/exam-no",
        component: ExamNumberComponent,
        canActivate: [nigeriaOnlyCanActivate(pageRoutes.access.accessing)],
        data: {
          title: "Exam Number",
          titleI18n: "GENERAL.EXAM_NUMBER",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProvisioningRoutingModule {}
